



const URLS = {
    urlApiREDECO: "https://api.condusef.gob.mx",
    urlApiREUNE: "https://api-reune.condusef.gob.mx",
    urlApiSinergia: "https://condusef.sinergia.finance/condusef-api",
    // urlApiSinergia: "http://127.0.0.1:3001/condusef-api",
}

const Data = { URLS }


export default Data